export default __webpack_public_path__ + "static/ilica-ae37cdfdc1e33cafe3d0cd341d980810.png";